module.exports = __webpack_public_path__ + "public/SiteIcons/listCloseIcon.svg?8562618d";